import { Component } from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import autoBind from 'react-autobind';
import { connect } from 'react-redux';

import withComponentName from '../../../../decorators/withComponentName';

import Logo from '../../../../assets/logo.svg';

import './styles.css';

export class CorporateHeader extends Component {
  constructor(props) {
    super(props);
    autoBind(this);
  }

  goToRoute(url) {
    const { origin } = this.props;
    window.location.href = origin + url;
  }

  render() {
    const { origin, promobarHeight } = this.props;

    return (
      <div className="Header w-100" id="main-header">
        <div className="Header__mobile">
          <Link to="/">
            <img src={Logo} alt="CityFalconLogo" className="Header__logo" />
          </Link>
          <h1 className="Header__mobile--main">
            <div>ENTERPRISE SOLUTIONS</div>
            <div>for</div>
            <div>FINANCIAL INSTITUTIONS and STARTUPS</div>
          </h1>
          <h3 className="Header__mobile--second">
            <del>General</del>
            {' '}
            Personalised
          </h3>
          <p className="Header__mobile--third">Financial and Business News, Tweets, and Research</p>
          <h3 className="Header__mobile--second">
            For
            {' '}
            <del>everyone</del>
            {' '}
            YOUR CLIENTS
          </h3>
          <p className="Header__mobile--text">By Text and Voice</p>
          <div className="Header__buttons-container">
            <div
              style={{
                top: `${100 + promobarHeight}px`,
              }}
              className="Header__buttons"
            >
              <button
                type="button"
                className="Header__buttons--try-api"
                onClick={() => this.goToRoute('/financial-news-api')}
              >
                Try Out API
              </button>
              <button
                type="button"
                className="Header__buttons--contact-us"
                onClick={() => this.goToRoute('/contact-us')}
              >
                Contact Us
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

CorporateHeader.defaultProps = {
  origin: typeof window === 'object' ? window.location.origin : '',
};

CorporateHeader.propTypes = {
  origin: PropTypes.string,
};

const mapToStateProps = ({ promobar }) => ({
  promobarHeight: promobar.height,
});

export default withComponentName(connect(mapToStateProps)(CorporateHeader));
